export const getDataCallActionFallback = async (getter = () => {}, getterParams = [], action = () => {}, actionParams = []) => {
	if (!getter(...getterParams)) {
		await action(...actionParams);
	}
	return getter(...getterParams);
};
